import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import type { ListPageChartsResponse } from '../list-page-charts/types';

export const useGetUsersStats = (enabled = true) => {
	return useQuery({
		queryKey: ['users', 'stats'],
		enabled,
		queryFn: async () => {
			const { data } = await api.get<ListPageChartsResponse>('/management/user/stats');
			return data;
		},
	});
};
